import { captureAndClearNormalMap } from './patternHandling.js';
import { styleHandling } from './styleHandling.js';
import { pushTextUndoQueue } from './text/textUndoRedoUtils.js';
import { renderTextOnly, textsOfHandling } from './textHandling.js';
import { pushUndoQueue } from './undoRedoLogo.js';
import {
  computeMultiplierBasedOnRatio,
  currentProduct,
  defaultSize,
  mesh,
  scene,
  size,
  undoText,
  updateDecals,
  updateLogoSelect,
  realignLogoToSurface,
  undoPatterns,
} from './webGL.js';

const THREE = window.THREE;
export function UploadDecals() {
  const decalList = [];
  window.decals.forEach(function (d) {
    const temp = {
      Id: d.logo.Id,
      Thumbnail: d.logo.Thumbnail,
      Scale: d.logo.Scale,
      Rotate: d.logo.Rotate,
      Position: d.logo.Position,
      Orientation: d.logo.Orientation,
      MeshId: d.logo.meshID,
      IsPattern: d.logo.IsPattern,
      IsText: d.logo.IsText,
      Text: d.logo.Text,
      Color: d.logo.Color,
      Font: d.logo.Font,
      ratio: d.logo.ratio,
    };
    decalList.push(temp);
  });
  const meshesColors = [];
  mesh.forEach(function (d) {
    const temp = {
      Color: d.material.color,
      Opacity: d.material.opacity,
    };
    meshesColors.push(temp);
  });

  const obj = {};
  obj.decals = decalList;
  obj.meshesColors = meshesColors;
  obj.product = currentProduct;
  return JSON.stringify(obj);
}

export function UploadLogo(idx, id, onFinished) {
  if (idx < window.decals.length) {
    const file = window.decals[idx].logo.file;
    if (file != null) {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('id', id);
      const request = new XMLHttpRequest();
      request.open('POST', window.backEnd + '/umbraco/surface/products/uploadlogo', true);
      request.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          if (this.responseText.startsWith('error')) {
            alert('Upload logo failed');
          } else {
            window.decals[idx].logo.Thumbnail = this.responseText;
            UploadLogo(++idx, id);
          }
        }
      };
      request.send(formData);
    } else {
      UploadLogo(++idx, id);
    }
  } else {
    onFinished();
  }
}

export function getProductId() {
  return currentProduct;
}

export function getDecals() {
  updateDecals();
  const decalList = [];
  window.decals.forEach(function (d) {
    const temp = {
      Id: d.logo.Id,
      Thumbnail: d.logo.Thumbnail,
      Scale: d.logo.Scale,
      Rotate: d.logo.Rotate,
      Position: d.logo.Position,
      Orientation: d.logo.Orientation,
      MeshId: d.logo.meshID,
      ratio: d.logo.ratio,
    };
    decalList.push(temp);
  });

  return decalList;
}

export function getTexts() {
  const textLists = [];
  textsOfHandling.texts.forEach(function (d) {
    const temp = {
      Id: d.logo.Id,
      Scale: d.logo.Scale,
      Rotate: d.logo.Rotate,
      Position: d.logo.Position,
      Orientation: d.logo.Orientation,
      MeshId: d.logo.meshID,
      IsPattern: d.logo.IsPattern,
      IsText: d.logo.IsText,
      Text: d.logo.Text,
      Color: d.logo.Color,
      Font: d.logo.Font,
    };
    textLists.push(temp);
  });

  return textLists;
}

export function getColors() {
  const meshesColors = [];
  mesh.forEach(function (d) {
    if (d.overwriteColor != null) {
      const temp = {
        color: d.overwriteColor,
        id: d.id,
      };
      meshesColors.push(temp);
    }
  });

  return meshesColors;
}

export function getTextures() {
  const meshTexture = [];
  mesh.forEach(function (d) {
    if (d.updatedTexture != null) {
      const temp = {
        thumbnail: d.updatedTexture,
        id: d.id,
      };
      meshTexture.push(temp);
    }
  });

  return meshTexture;
}

export function getStyles() {
  if (!window.currentStyle?.Id) {
    return [];
  }

  return [
    {
      Id: window.currentStyle.Id,
      name: window.currentStyle.name,
      main_texture: window.currentStyle.main_texture,
      normal_texture: window.currentStyle.normal_texture,
      Scale: window.currentStyle.Scale || 1,
    },
  ];
}

export function LoadDecals(restore) {
  restore?.logos?.forEach(function (d) {
    const logo = Object.assign({}, d);
    // Only create Position if it's valid
    if (d?.Position && d.Position.x !== null && d.Position.x !== undefined) {
      logo.Position = new THREE.Vector3(d.Position.x, d.Position.y, d.Position.z);
    } else {
      logo.Position = null;
    }
    // Only create Orientation if it's valid
    if (d?.Orientation && d.Orientation._x !== null && d.Orientation._x !== undefined) {
      logo.Orientation = new THREE.Euler(
        d.Orientation._x,
        d.Orientation._y,
        d.Orientation._z,
        d.Orientation._order,
      );
    } else {
      logo.Orientation = null;
    }
    updateLogoSelect(logo);
    // Only load logo if Position is valid
    if (logo.Position && logo.Position instanceof THREE.Vector3) {
      LoadLogo(logo);
    }
  });

  pushUndoQueue();
  restore?.texts?.forEach(function (d) {
    let logo = Object.assign({}, d);
    logo.Position = new THREE.Vector3(d.Position.x, d.Position.y, d.Position.z);
    logo.Orientation = new THREE.Euler(
      d.Orientation._x,
      d.Orientation._y,
      d.Orientation._z,
      d.Orientation._order,
    );
    logo = renderTextOnly(logo, window.currentLogo);
    LoadLogo(logo, window.currentLogo, size, defaultSize, mesh, scene, window.decals);
    // LoadLogo already adds to window.decals, so we just need to update textsOfHandling.texts
    if (logo.decalMesh) {
      textsOfHandling.texts.push(logo.decalMesh);
    }
  });
  // Push all restored texts to undo queue
  // Check if there are any text objects in window.decals
  const hasTexts = window.decals.some((d) => d.logo && d.logo.IsText === true);
  if (hasTexts) {
    pushTextUndoQueue();
  }

  if (restore.colors != null) {
    for (let i = 0; i < restore.colors.length; i++) {
      let _color = restore.colors[i];
      let _subMesh = mesh.find((subMesh) => subMesh.id == _color.id);
      if (_subMesh != null) {
        const color = new THREE.Color(_color.color.r, _color.color.g, _color.color.b);
        _subMesh.defaultColor = _subMesh.material.color;
        _subMesh.overwriteColor = color;
        _subMesh.material.color = color;
      }
    }
  }
}

export function restoreTextures(restore) {
  if (restore.textures != null) {
    const tempTextures = [];
    for (let i = 0; i < restore.textures.length; i++) {
      let _texture = restore.textures[i];
      console.log(_texture);
      let _subMesh = mesh.find((subMesh) => subMesh.id == _texture.id);
      let texture = undefined;
      if (_subMesh != null) {
        // Store current values before loading new texture
        const _currentValue = {
          map: _subMesh.material.map,
          normalMap: _subMesh.material.normalMap,
          patternFile: _subMesh.patternFile,
          updatedTexture: _subMesh.updatedTexture,
        };

        console.log(_texture.thumbnail);
        const textureloader = new THREE.TextureLoader();
        textureloader.crossOrigin = 'Anonymous';
        texture = textureloader.load(_texture.thumbnail + '?not-from-cache-please');
        texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
        texture.repeat.set(8, 8);
        console.log(_subMesh);
        _subMesh.material.map = texture;
        captureAndClearNormalMap(_subMesh);
        _subMesh.material.transparent = false; // <-- Force the material to treat it as opaque
        _subMesh.material.alphaTest = 0;
        _subMesh.material.needsUpdate = true;
        _subMesh.updatedTexture = _texture.thumbnail;

        const _value = {
          map: texture,
          normalMap: null,
          patternFile: _texture.thumbnail,
          updatedTexture: _texture.thumbnail,
        };

        tempTextures.push({
          id: _subMesh.id,
          type: 'pattern',
          value: _value,
          currentValue: _currentValue,
          uuid: _subMesh?.uuid,
          mesh: _subMesh,
        });
      }
    }

    // Clear existing patterns and push new ones (can't reassign Proxy object)
    undoPatterns.length = 0;
    undoPatterns.push(...tempTextures);
  }
}

export function loadFonts(restore, finished) {
  let fonts = [];
  restore?.texts?.forEach(function (d) {
    if (d.IsText && d.Font !== 'Arial') {
      fonts.push(d.Font);
    }
  });
  if (fonts.length > 0) {
    console.log(fonts);
    // WebFont && WebFont?.load({
    //   google: {
    //     families: fonts,
    //   },
    //   loading: function () {
    //     console.log("Fonts are being loaded");
    //   },
    //   active: function () {
    //     console.log("Fonts loaded");
    //     finished();
    //   },
    // });
    finished();
  } else {
    finished();
  }
}

export function restoreStyles(restore) {
  if (!restore.styles?.length) {
    return;
  }

  const savedStyle = restore.styles[0];
  console.log('Restoring style:', savedStyle);

  if (!savedStyle?.main_texture) {
    return;
  }

  if (!styleHandling) {
    return;
  }
  styleHandling.applyStyleToAllSections(savedStyle);
  window.currentStyle = savedStyle;
  window.currentAppliedStyleId = savedStyle.Id;
}

export function LoadLogo(logo) {
  window.currentLogo = logo;
  const scale = window.currentLogo.Scale;
  // Tính toán kích thước dựa trên aspect ratio để tránh bóp méo
  const { multiplierX, multiplierY } = computeMultiplierBasedOnRatio(window.currentLogo.ratio ?? 1);
  if (logo.IsText) {
    size.set(scale, scale, scale);
  } else {
    size.set(
      scale * defaultSize * multiplierX,
      scale * defaultSize * multiplierY,
      scale * defaultSize,
    );
  }
  const orientationTemp = new THREE.Euler();
  // Ensure Orientation is a valid THREE.Euler instance before copying
  if (
    window.currentLogo.Orientation &&
    window.currentLogo.Orientation instanceof THREE.Euler &&
    typeof window.currentLogo.Orientation.copy === 'function'
  ) {
    orientationTemp.copy(window.currentLogo.Orientation);
  }
  orientationTemp.z += (window.currentLogo.Rotate * Math.PI) / 180;

  // Validate Position before creating DecalGeometry
  if (!window.currentLogo.Position || !(window.currentLogo.Position instanceof THREE.Vector3)) {
    console.error('LoadLogo: Invalid Position for logo', window.currentLogo);
    return;
  }

  const material = window.currentLogo.decalMaterial;
  if (window.currentLogo.MeshId != null && mesh.length > window.currentLogo.MeshId) {
    window.currentLogo.decalMesh = new THREE.Mesh(
      new THREE.DecalGeometry(
        mesh[window.currentLogo.MeshId],
        window.currentLogo.Position,
        orientationTemp,
        size,
      ),
      material,
    );
  } else {
    window.currentLogo.decalMesh = new THREE.Mesh(
      new THREE.DecalGeometry(mesh, window.currentLogo.Position, orientationTemp, size),
      material,
    );
  }
  window.currentLogo.decalMesh.logo = window.currentLogo;

  scene.add(window.currentLogo.decalMesh);
  window.decals.push(window.currentLogo.decalMesh);
  realignLogoToSurface(window.currentLogo);
}
